'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Vortex = function (_React$Component) {
	(0, _inherits3.default)(Vortex, _React$Component);

	function Vortex() {
		(0, _classCallCheck3.default)(this, Vortex);
		return (0, _possibleConstructorReturn3.default)(this, (Vortex.__proto__ || Object.getPrototypeOf(Vortex)).apply(this, arguments));
	}

	(0, _createClass3.default)(Vortex, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerVortex' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '3285278599',
					css: '.BurgerVortex .BurgerInner{-webkit-transition-duration:0.2s;transition-duration:0.2s;-webkit-transition-timing-function:cubic-bezier(0.19,1,0.22,1);transition-timing-function:cubic-bezier(0.19,1,0.22,1);}.BurgerVortex .BurgerInner:before,.BurgerVortex .BurgerInner:after{-webkit-transition-duration:0s;transition-duration:0s;-webkit-transition-delay:0.1s;transition-delay:0.1s;-webkit-transition-timing-function:linear;transition-timing-function:linear;}.BurgerVortex .BurgerInner:before{-webkit-transition-property:top,opacity;transition-property:top,opacity;}.BurgerVortex .BurgerInner:after{-webkit-transition-property:bottom,-webkit-transform;-webkit-transition-property:bottom,transform;transition-property:bottom,transform;}.BurgerVortex.BurgerActive .BurgerInner{-webkit-transform:rotate(765deg);-ms-transform:rotate(765deg);transform:rotate(765deg);-webkit-transition-timing-function:cubic-bezier(0.19,1,0.22,1);transition-timing-function:cubic-bezier(0.19,1,0.22,1);}.BurgerVortex.BurgerActive .BurgerInner:before,.BurgerVortex.BurgerActive .BurgerInner:after{-webkit-transition-delay:0s;transition-delay:0s;}.BurgerVortex.BurgerActive .BurgerInner:before{top:0;opacity:0;}.BurgerVortex.BurgerActive .BurgerInner:after{bottom:0;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/vortex.js */'
				})
			);
		}
	}]);
	return Vortex;
}(_react2.default.Component);

exports.default = Vortex;


Vortex.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=vortex.js.map